// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"f14004c4","563":"93d5ea3c","790":"06b9e90d","844":"2c3314ea"}[chunkId] + ".chunk.js";
};